import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {INewCompany} from '../../shared/model/interface/new-company.model.interface';

@Injectable({
  providedIn: 'root'
})
export class GusService {
  private URL = environment.backendUrl + '/gus/';

  constructor(private http: HttpClient) {
  }

  findByNip(nip: string): Observable<any> {
    return this.findCompany('NIP', nip);
  }

  findByRegon(regon: string): Observable<any> {
    return this.findCompany('REGON', regon);
  }

  reportsByRegon(regon: string): Observable<any> {
    return this.getReports('REGON', regon);
  }

  reportsByNip(nip: string): Observable<any> {
    return this.getReports('NIP', nip);
  }

  private findCompany(paramName: 'NIP' | 'REGON', paramValue: string): Observable<INewCompany> {
    const params: HttpParams = new HttpParams()
      .append('paramName', paramName)
      .append('paramValue', paramValue);

    return this.http.get<INewCompany>(this.URL + 'company-data', {
      params,
    });
  }

  private getReports(paramName: 'NIP' | 'REGON', paramValue: string): Observable<any> {
    const params: HttpParams = new HttpParams()
      .append('paramName', paramName)
      .append('paramValue', paramValue);

    return this.http.get<INewCompany>(this.URL + 'reports', {
      params,
    });
  }
}
